import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class InnerRoutesService {
  private _innerRoutesVisible$ = new BehaviorSubject<boolean>(false);
  innerRoutesVisible$ = this._innerRoutesVisible$.asObservable();

  showInnerRoutes() {
    this._innerRoutesVisible$.next(true);
  }

  hideInnerRoutes() {
    this._innerRoutesVisible$.next(false);
  }
}
